export default class PostView {
  constructor() {
    this.eventHandlers = {};
    this.postId = null;
  }

  async render() {
    return `
      <div id="page-post" class="page-content active">
        <div class="empty-state">
          <span class="material-symbols-rounded">info</span>
          <h3>Post Detail</h3>
          <p id="post-detail-text"></p>
          <button type="button" id="back-btn" class="post-submit" data-text_tip="Kembali">
            <span class="material-symbols-rounded" aria-hidden="true">arrow_back</span>
            <span>Kembali</span>
          </button>
        </div>
      </div>`;
  }

  async afterRender() {
    const text = document.getElementById('post-detail-text');
    if (text) {
      text.textContent = `Post ID: ${this.postId} - Feature will be implemented`;
    }
    const btn = document.getElementById('back-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        if (this.eventHandlers.onBack) this.eventHandlers.onBack();
      });
    }
  }

  setPostId(id) {
    this.postId = id;
  }

  onBack(handler) {
    this.eventHandlers.onBack = handler;
  }

  cleanup() {}
}
